import React from "react";
import {RequestPayload} from "../sites/types/RequestPayload";

export enum DeliveryProgress {
  CAPTURE = "capture",
  ON_WAY = "onWay",
  AT_DELIVERY = "atDelivery",
  DELIVERED = "delivered",
}

/**
 * React Component properties
 */
type Props = {
  searchResult: RequestPayload;
};

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This component is used to display the progress of the delivery in a horizontal progress bar (mobile vertical)
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export default function DeliveryProgressBar(props: Props) {

  return (
    <div style={{ width: "100%" }} className={"delivery_progress_container"}>
      <div className="delivery_progress_bar">
        <div
          className={"progress_indicator"}
          data-step={props.searchResult.deliveryProgress}
        />
        <div className={"progress_element"}>
          <div className={"progress_circle"} />
        </div>

        <div className={"progress_element"}>
          <div className={"progress_circle"} />
          <div className={"progress_circle"} />
        </div>

        <div className={"progress_element"}>
          <div className={"progress_circle"} />
        </div>
      </div>

      <div className={"delivery_progress_infos"}>
        <div className={"delivery_progress_info_element"}>
          <h2>Erfassung</h2>
          <p>der Sendung von {props.searchResult.senderName}</p>
        </div>

        <div className={"delivery_progress_info_element"}>
          <h2>Unterwegs</h2>
          <p>das Stückgut wird zum Depot transportiert</p>
        </div>

        <div className={"delivery_progress_info_element"}>
          <h2>In Zustellung</h2>
          <p>das Stückgut wurde verladen und befindet sich in der Zustellung</p>
        </div>

        <div className={"delivery_progress_info_element"}>
          <h2>Zugestellt</h2>
          <p>das Stückgut wurde beim Empfänger zugestellt</p>
        </div>
      </div>
    </div>
  );
}
